import { Box, LinearProgress, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom/dist";
import CoreHttpHandler from "../http/services/CoreHttpHandler";
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import { Button, DatePicker, Dropdown, Input, Menu, Pagination } from 'antd';
import moment from "moment";
import CustomTextLimit from "../assets/global-components/TextLimit";
import { ToastAlertError } from "../reauseble";

const { RangePicker } = DatePicker;

const LegalnRegInfoCat = () => {

	const location = useLocation();
	const navigate = useNavigate();
	const [posts, setPosts] = useState([]);
	const [allPosts, setAllPosts] = useState([]);
	const [clients, setClients] = useState([]);
	const [resources, setResources] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [searchTitle, setSearchTitle] = useState("");
	const [selectedSource, setSelectedSource] = useState("");
	const [selectedOrder, setSelectedOrder] = useState("DESC");
	const [selectedSourceName, setSelectedSourceName] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [dateRange, setdateRange] = useState({
		startDate: null,
		endDate: null
	});
	const pageSize = 10;

	const getPosts = (searchParams = {}) => {
		const categoryId = location?.state?.id;
		console.log("getPosts called with categoryId:", categoryId);

		if (!categoryId) {
			console.log("No category ID found in location state");
			setIsLoading(false);
			return;
		}

		const requestParams = {
			category_id: categoryId,
			nav_id: 1,
			creator_id: null,
			_s: searchParams.title || null,
			resource_id: searchParams.resourceId || null,
			start_date: searchParams.startDate || null,
			end_date: searchParams.endDate || null,
			limit: 10000,
			page: 1,
			post_status: "publish",
			order_by: selectedOrder || null,
		};

		console.log("Making API request with params:", requestParams);
		setIsLoading(true)

		CoreHttpHandler.request(
			"library",
			"fetchSearchedPosts",
			requestParams,
			(res) => {
				try {
					console.log("API Response:", res);
					console.log("API Response data:", res?.data);
					console.log("API Response data.data:", res?.data?.data);
					setAllPosts(res?.data?.data?.posts?.posts || []);
					setIsLoading(false)
				} catch (e) {
					console.log("Error processing response:", e);
					setIsLoading(false)
				}
			},
			(err) => {
				setIsLoading(false)
				console.log("API Error:", err);
				ToastAlertError(
					err?.response?.data?.message
						? err?.response.data.message
						: "something went wrong"
				);
			}
		);
	};


	const filterPosts = () => {
		// Call API with search parameters
		getPosts({
			title: searchTitle || null,
			resourceId: selectedSource || null,
			startDate: dateRange.startDate ? moment(dateRange.startDate).format("YYYY-MM-DD") : null,
			endDate: dateRange.endDate ? moment(dateRange.endDate).format("YYYY-MM-DD") : null,
		});
	};

	const applyClientFilters = () => {
		if (!allPosts || allPosts.length === 0) {
			setPosts([]);
			return;
		}

		let filtered = [...allPosts];

		const sorted = filtered.sort((a, b) =>
			selectedOrder === "ASC"
				? a.id - b.id
				: b.id - a.id
		);

		setPosts(sorted);
		setCurrentPage(1);
	};

	const paginatedPosts = posts.slice(
		(currentPage - 1) * pageSize,
		currentPage * pageSize
	);




	const getResources = () => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"library",
			"fetchResources",
			{
				"limit": 1000,
				"page": 1,
				"category_nav_id": 1,
			},
			(res) => {

				setResources(res.data.data.resources?.resources);
				setIsLoading(false);
				// ToastAlertSuccess("Item removed Successfully");
			},
			(err) => {
				// ToastAlertError(
				// 	err?.response?.data?.message
				// 		? err?.response.data.message
				// 		: "something went wrong"
				// );
			}
		);
	};

	// const handleBtnClick = (data) => {
	// 	console.log(data)
	// 	navigate(`${location.pathname}/${data.title}`, {
	// 		state: {
	// 			...data,
	// 		},
	// 	});
	// }

	const handleDownload = (url) => {
		// window.location.href = url;
		window.open(url, '_blank');
	};

	useEffect(() => {
		console.log("Location state changed:", location?.state);
		getPosts();
		getResources();
	}, [location?.state?.id]);

	useEffect(() => {
		applyClientFilters();
	}, [allPosts, selectedOrder]);

	const handleOnDateChange = (date, name) => {
		let datesOBJ = { ...dateRange };
		if (name == 'start') {
			datesOBJ.startDate = date;
		} else {
			datesOBJ.endDate = date;
		}
		setdateRange(datesOBJ);
	};
	const handleSourceMenuClick = (e) => {

		setSelectedSource(e.key);
		setSelectedSourceName(e?.domEvent?.target?.textContent);
	};
	const handleOrderMenuClick = (e) => {
		setSelectedOrder(e.key);
	};
	const handleTitleMenuClick = (e) => {
		// console.log('Clicked on:', e.key);
	};
	const clearSearch = () => {
		setSearchTitle("");
		setdateRange({ startDate: null, endDate: null });
		setSelectedSource("");
		setSelectedSourceName("");
		setCurrentPage(1);
		getPosts(); // Reset to all posts
	};

	const sourcesMenu = (
		<Menu onClick={handleSourceMenuClick}>
			{resources?.map((val) => {
				return <>
					<Menu.Item key={val.id}>{val.name}</Menu.Item>
				</>
			})}
		</Menu>
	);
	const orderMenu = (
		<Menu onClick={handleOrderMenuClick}>
			<Menu.Item key={"ASC"}>ASC</Menu.Item>
			<Menu.Item key={"DESC"}>DESC</Menu.Item>
		</Menu>
	);
	const titleMenu = (
		<Menu onClick={handleTitleMenuClick}>
			<Menu.Item key="1">Option 1</Menu.Item>
			<Menu.Item key="2">Option 2</Menu.Item>
			<Menu.Item key="3">Option 3</Menu.Item>
		</Menu>
	);

	return (
		<>

			<PageHeader heading={location?.state?.name} />
			{/* <div className="content_wrap"> */}
			<div className="content_wrap lnrInfoCat">

				<section className='sec sec2'>

					<Container style={{ animation: "fadeInUp 0.5s ease both" }}>
						<Row className="d-flex align-items-center justify-content-center">
							<Col lg={2} md={4} xs={12} style={{ marginBottom: "10px" }}>
								<Dropdown overlayStyle={{ maxHeight: "300px", overflowY: "scroll" }}
									overlay={sourcesMenu}
									trigger={['click']}
								>
									<Button
										value={selectedSource}
										style={{ width: "100%", textAlign: "left", borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
										onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; }}
										onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; }}
									>
										{selectedSourceName?.substring(0, 20) || "Resources"}
									</Button>
								</Dropdown>
							</Col>
							<Col lg={3} md={4} xs={12} style={{ marginBottom: "10px" }}>
								<Input
									value={searchTitle}
									style={{ width: "100%", borderRadius: "20px", padding: "8px 15px", transition: "all 0.3s ease", border: "1px solid #d9d9d9" }}
									onFocus={(e) => e.target.style.boxShadow = "0 0 0 3px rgba(7,88,143,0.1)"}
									onBlur={(e) => e.target.style.boxShadow = "none"}
									onChange={(e) => setSearchTitle(e.target.value)}
									placeholder="Title"
								/>
							</Col>

							<Col xl={2} lg={2.5} md={4} xs={6} style={{ marginBottom: "10px" }}>
								<div className="text-center">
									<div className="dateRangeDiv ct-inputdiv">
										<TextField
											id="sd"
											type="date"
											min="2020-01-01"
											max="2030-12-31"
											onChange={e => {
												handleOnDateChange(e.target.value, 'start');
											}}
											InputProps={{
												style: {
													height: '36px',
													padding: '0 14px',
													borderRadius: '20px',
												},
											}}
										/>
									</div>
								</div>
							</Col>

							<Col xl={2} lg={2.5} md={4} xs={6} style={{ marginBottom: "10px" }}>
								<div className="text-center">
									<div className="ct-inputdiv">
										<TextField
											InputLabelProps={{
												shrink: true
											}}
											id="ed"
											type="date"
											min="2020-02-01"
											max="2030-12-31"
											onChange={e => {
												handleOnDateChange(e.target.value, 'end');
											}}
											InputProps={{
												style: {
													height: '36px',
													padding: '0 14px',
													borderRadius: '20px',
												},
											}}
										/>
									</div>
								</div>
							</Col>
							<Col lg={1} md={2} xs={3} style={{ marginBottom: "10px" }}>
								<Dropdown overlayStyle={{ maxHeight: "300px", overflowY: "scroll" }}
									overlay={orderMenu}
									trigger={['click']}
								>
									<Button
										value={selectedOrder}
										style={{ width: "100%", borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
										onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; }}
										onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; }}
									>
										{selectedOrder}
									</Button>
								</Dropdown>
							</Col>
							<Col lg={2} md={4} xs={6} style={{ marginBottom: "10px", display: "flex", gap: "8px" }}>
								<Button
									style={{ background: "#07588f", color: "#fff", border: "none", flex: 1, borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
									onMouseEnter={(e) => { e.currentTarget.style.background = "#0a6ebd"; e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(7,88,143,0.3)"; }}
									onMouseLeave={(e) => { e.currentTarget.style.background = "#07588f"; e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
									onClick={() => filterPosts()}
								>
									Search
								</Button>
								<Button
									style={{ flex: 1, borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
									onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; e.currentTarget.style.transform = "translateY(-2px)"; }}
									onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; e.currentTarget.style.transform = "translateY(0)"; }}
									onClick={clearSearch}
								>
									Clear
								</Button>
							</Col>
						</Row>
					</Container>

					<div className='container'>


						<div>
							{isLoading ?
								<Box sx={{ my: '5rem' }}>
									<LinearProgress color="success" />
								</Box>
								:
								paginatedPosts?.map((e) => {
									return <>
										<Card className="legalnRegCatcards flex_btw">
											<Container>
												<Row className="d-flex align-items-center">
													<Col lg={2} md={4} xs={12} >
														<div className="img_box">
															<img src={e.image ? e.image : location.state.image} />
														</div>
													</Col>
													<Col lg={7} md={4} xs={12} >
														<div className="div1">
															<CustomTextLimit limit={50} title text={e.post_title} />
															<CustomTextLimit text={e.post_content} />
														</div>
													</Col>
													<Col lg={3} md={4} xs={12} >
														<div className="div2">
															<button className="rounded_btn" disabled={!e.url} onClick={() => handleDownload(e.url)} variant="primary">Read More</button>
															<p>Published Date</p><p>{moment(e?.date).format("DD-MM-YYYY")}</p>
														</div>
													</Col>
												</Row>
											</Container >
										</Card>
									</>
								})
							}

						</div>

						<Pagination
							total={posts.length}
							current={currentPage}
							pageSize={pageSize}
							hideOnSinglePage
							onChange={(page) => setCurrentPage(page)} />
					</div>
				</section >

			</div >
			{/* </div> */}
		</>
	);
};

export default LegalnRegInfoCat;
